// src/modules/Profile/adapters/ProfileApiAdapter.ts

import { HttpClient } from '@adapters/HttpClient';
import { UpdateEmailPayload, UpdateUserPayload } from '../models/Payloads';
import { Profile } from '../models/Profile';

export class ProfileApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getCurrentUserProfile(): Promise<Profile> {
    return await this.httpClient.get<Profile>('/me');
  }

  async updateUser(payload: UpdateUserPayload): Promise<void> {
    // Solo obtener el userId, no todo el perfil para evitar enviar datos corruptos
    const profile = await this.getCurrentUserProfile();
    const userId = profile.user.id;

    const formData = new FormData();

    // Solo agregar campos que están siendo actualizados
    if (payload.name !== undefined) {
      formData.append('name', payload.name);
    }

    if (payload.password) {
      formData.append('password', payload.password);
    }

    if (payload.current_password) {
      formData.append('current_password', payload.current_password);
    }

    if (payload.profile_photo_file) {
      formData.append('profile_photo_path', payload.profile_photo_file, payload.profile_photo_file.name);
    }

    await this.httpClient.post(`/users/${userId}`, formData, true, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
  }

  async updateEmail(payload: UpdateEmailPayload): Promise<void> {
    await this.httpClient.put(`/users/change-email`, payload);
  }
}
